import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import OrdersList from './components/OrdersList';
import { isEmpty } from 'utils/types';
import { constants as recurringOrderConstants } from 'utils/recurringOrder';
import {
  actions as ordersActions,
  selectors as ordersSelectors,
} from 'state/orders';
import { useDispatch, useSelector } from 'react-redux';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import { actions as orderActions } from 'state/order';

const Orders = ({ type, className }) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(ordersSelectors.isFetching);
  const searchText = useSelector(ordersSelectors.getSearchText);
  const isTypeRecurring = type === recurringOrderConstants.RECURRING;
  const orders = useSelector(
    isTypeRecurring
      ? ordersSelectors.getRecurringOrdersIdsByStatus
      : ordersSelectors.getOrdersIdsByDate
  );

  useEffect(() => {
    dispatch(ordersActions.resetData());
    dispatch(ordersActions.fetchOrders({ type }));
    if (type === 'active') {
      dispatch(ordersActions.fetchOrdersStartPolling({ type }));
    }
    dispatch(
      analyticsActions.sendEvent(
        analyticsEvents.orders.list.shipmentsViewed({ type })
      )
    );
    dispatch(orderActions.cleanRepeatAndEditing());
    return () => {
      dispatch(ordersActions.fetchOrdersStopPolling());
    };
  }, [dispatch, type]);

  return (
    <div className={className} data-testid="orders">
      <OrdersList
        orders={orders}
        type={type}
        isFetching={isFetching}
        isEmpty={isEmpty(orders) && isEmpty(searchText)}
      />
    </div>
  );
};

Orders.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
};

export default Orders;
